module.exports = __webpack_public_path__ + "static/img/1064.effe02c.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/1064.jpg
// module id = 246
// module chunks = 0